"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorCard = exports.GradientCard = exports.BlackCardPaintSilver = exports.BlackCard = exports.BasicCard = void 0;
const react_1 = __importDefault(require("react"));
const card_1 = require("./card");
const BasicCard = () => {
    var card_ref;
    return react_1.default.createElement("div", { style: { width: "360px" } },
        react_1.default.createElement(card_1.Card, { ref: (el) => { card_ref = el; }, logo: "./static/your_logo.png", code: true }),
        react_1.default.createElement("button", { onClick: () => { card_ref.flip(); } }, "flip"));
};
exports.BasicCard = BasicCard;
const BlackCard = () => {
    var card_ref;
    return react_1.default.createElement("div", { style: { width: "360px" } },
        react_1.default.createElement(card_1.Card, { ref: (el) => { card_ref = el; }, logo: "./static/your_logo.png", faceColor: "black", paintColor: "gold", code: true }),
        react_1.default.createElement("button", { onClick: () => { card_ref.flip(); } }, "flip"));
};
exports.BlackCard = BlackCard;
const BlackCardPaintSilver = () => {
    var card_ref;
    return react_1.default.createElement("div", { style: { width: "360px" } },
        react_1.default.createElement(card_1.Card, { ref: (el) => { card_ref = el; }, logo: "./static/your_logo.png", faceColor: "black", paintColor: "silver", signature: "Linda Evans", code: true }),
        react_1.default.createElement("button", { onClick: () => { card_ref.flip(); } }, "flip"));
};
exports.BlackCardPaintSilver = BlackCardPaintSilver;
const GradientCard = () => {
    var card_ref;
    return react_1.default.createElement("div", { style: { width: "360px" } },
        react_1.default.createElement(card_1.Card, { ref: (el) => { card_ref = el; }, logo: "./static/your_logo.png", faceColor: "gradient", paintColor: "white", code: true }),
        react_1.default.createElement("button", { onClick: () => { card_ref.flip(); } }, "flip"));
};
exports.GradientCard = GradientCard;
const ColorCard = () => {
    var card_ref;
    return react_1.default.createElement("div", { style: { width: "360px" } },
        react_1.default.createElement(card_1.Card, { ref: (el) => { card_ref = el; }, logo: "./static/your_logo_color.png", faceColor: "white", paintColor: "color", code: true }),
        react_1.default.createElement("button", { onClick: () => { card_ref.flip(); } }, "flip"));
};
exports.ColorCard = ColorCard;
//# sourceMappingURL=card.composition.js.map